import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Gabarito() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Recebe os dados passados pelo botão "Preencher Gabarito" da tela anterior
  const { aluno, avaliacaoId, qtdQuestoes, qtdAlternativas } = location.state || {};

  // Estado para armazenar as respostas no formato {"1": "A", "2": "C"}
  const [respostas, setRespostas] = useState({});
  const [loading, setLoading] = useState(false);

  // Função para lidar com o clique na bolinha
  const handleSelect = (numeroQuestao, letraAlternativa) => {
    setRespostas(prev => ({
      ...prev,
      [numeroQuestao]: letraAlternativa
    }));
  };

  const handleSalvar = async () => {
    // Validação simples para ver se o professor preencheu todas as questões
    const questoesRespondidas = Object.keys(respostas).length;
    if (questoesRespondidas < qtdQuestoes) {
      const confirmar = window.confirm(`Você preencheu apenas ${questoesRespondidas} de ${qtdQuestoes} questões. Deseja salvar mesmo assim?`);
      if (!confirmar) return;
    }

    setLoading(true);
    try {
      // Monta o objeto exatamente como o backend/banco de dados espera
      const payload = {
        avaliacao_id: avaliacaoId,
        aluno_id: aluno.id,
        resultado: respostas
      };

      // Rota POST que você solicitou
      await api.post('/resultadosobjetivas/', payload);

      alert('Gabarito salvo com sucesso!');
      navigate(-1); // Volta para a lista de alunos, e o aluno salvo ficará verdinho!
    } catch (error) {
      console.error("Erro ao salvar gabarito:", error);
      // Se o erro for 409 (Conflito), significa que a trava UNIQUE do banco funcionou
      if (error.response && error.response.status === 409) {
        alert("Este aluno já possui um gabarito registrado para esta avaliação.");
      } else {
        alert("Erro ao salvar. Verifique sua conexão e o console.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Gerador de array de letras baseado na quantidade (ex: 4 = ['A', 'B', 'C', 'D'])
  const gerarLetras = (quantidade) => {
    return Array.from({ length: quantidade }, (_, i) => String.fromCharCode(65 + i));
  };

  const alternativas = gerarLetras(qtdAlternativas || 5); // Fallback para 5 se vier vazio

  if (!aluno) {
    return <div style={styles.center}>Dados do aluno não encontrados.</div>;
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>Voltar</button>
        <div style={styles.headerTitle}>
          <h2 style={styles.title}>Preencher Gabarito</h2>
          <p style={styles.subtitle}>Aluno(a): <strong>{aluno.nome}</strong></p>
        </div>
      </header>

      <div style={styles.content}>
        <div style={styles.instrucaoBox}>
          <p style={styles.instrucaoText}>
            Selecione a resposta marcada pelo aluno em cada questão.
          </p>
        </div>

        <div style={styles.gabaritoList}>
          {Array.from({ length: qtdQuestoes }).map((_, index) => {
            const numeroQuestao = index + 1;
            const respostaSelecionada = respostas[numeroQuestao];

            return (
              <div key={numeroQuestao} style={styles.questaoRow}>
                <div style={styles.questaoNum}>{numeroQuestao}</div>
                <div style={styles.alternativasContainer}>
                  {alternativas.map((letra) => {
                    const isSelected = respostaSelecionada === letra;
                    return (
                      <button
                        key={letra}
                        onClick={() => handleSelect(numeroQuestao, letra)}
                        style={{
                          ...styles.bolinha,
                          backgroundColor: isSelected ? '#5d9e03' : '#f0f0f0',
                          color: isSelected ? '#fff' : '#555',
                          borderColor: isSelected ? '#3f8c00' : '#ddd',
                        }}
                      >
                        {letra}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <button 
          onClick={handleSalvar} 
          style={styles.saveBtn} 
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar Gabarito'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '600px', margin: '0 auto', backgroundColor: '#F8F9FA', minHeight: '100vh', display: 'flex', flexDirection: 'column' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666' },
  header: { display: 'flex', alignItems: 'center', padding: '20px', backgroundColor: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  backBtn: { marginRight: '15px', background: 'none', border: 'none', color: '#5d9e03', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' },
  headerTitle: { flex: 1 },
  title: { margin: 0, fontSize: '20px', color: '#333' },
  subtitle: { margin: '4px 0 0 0', color: '#666', fontSize: '14px' },
  content: { padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' },
  instrucaoBox: { backgroundColor: '#e8f5e9', padding: '12px', borderRadius: '8px', marginBottom: '20px', borderLeft: '4px solid #3f8c00' },
  instrucaoText: { color: '#2e7d32', margin: 0, fontSize: '14px', fontWeight: '500' },
  gabaritoList: { flex: 1, marginBottom: '20px' },
  questaoRow: { display: 'flex', alignItems: 'center', backgroundColor: '#fff', padding: '12px 15px', borderRadius: '8px', marginBottom: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', border: '1px solid #eee' },
  questaoNum: { fontSize: '16px', fontWeight: 'bold', color: '#333', width: '30px' },
  alternativasContainer: { display: 'flex', gap: '10px', flex: 1, justifyContent: 'flex-start' },
  bolinha: { width: '40px', height: '40px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', border: '2px solid', transition: 'all 0.2s' },
  saveBtn: { width: '100%', padding: '15px', backgroundColor: '#3f8c00', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 4px 6px rgba(63, 140, 0, 0.3)' }
};